// Страница входа в систему: форма с email и паролем, авторизация через authStore.

import { useState } from 'react';
import { Container, Card, Form, Button, Alert } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import useAuthStore from '../../store/authStore';
import { resendVerification } from '../../api/authApi';

export default function LoginPage() {
  const [email, setEmail] = useState(() => localStorage.getItem('lastEmail') ?? '');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [errorVariant, setErrorVariant] = useState('danger');
  const [loading, setLoading] = useState(false);
  const [resendState, setResendState] = useState('idle'); // 'idle' | 'loading' | 'sent'
  const login = useAuthStore((s) => s.login);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setErrorVariant('danger');
    setLoading(true);
    setResendState('idle');
    try {
      await login(email, password);
      localStorage.setItem('lastEmail', email);
      // login() уже загрузил user через /users/me; читаем его из стора
      const currentUser = useAuthStore.getState().user;
      const roles = currentUser?.roles ?? [];
      const isOnlyStudent = roles.length > 0 && roles.every((r) => r === 'student');
      navigate(isOnlyStudent ? '/student' : '/dashboard');
    } catch (err) {
      if (err.response?.status === 403) {
        setErrorVariant('warning');
        setError('Email не подтверждён. Проверьте почту и перейдите по ссылке из письма.');
      } else {
        setErrorVariant('danger');
        setError('Неверный email или пароль');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ewl-auth-page">
      <Container>
        <div className="ewl-auth-card">
          {/* Логотип */}
          <div className="text-center mb-4">
            <div
              className="d-inline-flex align-items-center justify-content-center mb-3"
              style={{
                width: '3.5rem',
                height: '3.5rem',
                borderRadius: '1rem',
                background: 'linear-gradient(135deg, #4f6ef7 0%, #7c3aed 100%)',
                fontSize: '1.5rem',
                boxShadow: '0 4px 16px rgba(79,110,247,0.35)',
              }}
            >
              📖
            </div>
            <h4 className="fw-bold mb-1" style={{ letterSpacing: '-0.01em' }}>
              English We Love
            </h4>
            <p className="text-muted mb-0" style={{ fontSize: '0.875rem' }}>
              Войдите в свой аккаунт
            </p>
          </div>

          <Card className="border-0" style={{ borderRadius: '1rem', boxShadow: '0 4px 24px rgba(0,0,0,0.09)' }}>
            <Card.Body className="p-4">
              {error && (
                <Alert variant={errorVariant} className="py-2 px-3 mb-3" style={{ fontSize: '0.875rem', borderRadius: '0.5rem' }}>
                  {error}
                  {errorVariant === 'warning' && (
                    <div className="mt-2">
                      <Button
                        variant="outline-warning"
                        size="sm"
                        disabled={resendState === 'loading' || resendState === 'sent'}
                        onClick={async () => {
                          setResendState('loading');
                          try {
                            await resendVerification(email);
                            setResendState('sent');
                          } catch {
                            setResendState('idle');
                          }
                        }}
                        style={{ borderRadius: '0.4rem', fontSize: '0.8rem' }}
                      >
                        {resendState === 'loading' && 'Отправляем...'}
                        {resendState === 'sent' && '✓ Письмо отправлено'}
                        {resendState === 'idle' && 'Отправить письмо повторно'}
                      </Button>
                    </div>
                  )}
                </Alert>
              )}

              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label className="fw-medium" style={{ fontSize: '0.875rem' }}>
                    Email
                  </Form.Label>
                  <Form.Control
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="you@example.com"
                    size="lg"
                    required
                    style={{ borderRadius: '0.5rem' }}
                  />
                </Form.Group>

                <Form.Group className="mb-4">
                  <div className="d-flex justify-content-between align-items-baseline mb-1">
                    <Form.Label className="fw-medium mb-0" style={{ fontSize: '0.875rem' }}>
                      Пароль
                    </Form.Label>
                    <Link
                      to="/forgot-password"
                      style={{
                        fontSize: '0.8rem',
                        color: 'var(--bs-secondary)',
                        textDecoration: 'none',
                      }}
                    >
                      Забыли пароль?
                    </Link>
                  </div>
                  <Form.Control
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                    size="lg"
                    required
                    style={{ borderRadius: '0.5rem' }}
                  />
                </Form.Group>

                <Button
                  type="submit"
                  size="lg"
                  className="w-100"
                  disabled={loading}
                  style={{
                    background: 'linear-gradient(135deg, #4f6ef7 0%, #7c3aed 100%)',
                    border: 'none',
                    borderRadius: '0.6rem',
                    fontWeight: 600,
                    letterSpacing: '0.01em',
                  }}
                >
                  {loading ? 'Входим...' : 'Войти'}
                </Button>
              </Form>
            </Card.Body>
          </Card>

          <p className="text-center mt-3 text-muted" style={{ fontSize: '0.875rem' }}>
            Нет аккаунта?{' '}
            <Link
              to="/register"
              style={{ color: 'var(--bs-primary)', fontWeight: 500, textDecoration: 'none' }}
            >
              Зарегистрироваться
            </Link>
          </p>
        </div>
      </Container>
    </div>
  );
}
